var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "#336AE9",
    stroke: "#DBE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28.4946C26.8911 28.4946 25.5167 27.9331 24.3767 26.8099C23.2367 25.6869 22.6667 24.3328 22.6667 22.7473C22.6667 21.1622 23.2367 19.808 24.3767 18.6848C25.5167 17.5616 26.8911 17 28.5 17C30.1089 17 31.4833 17.5616 32.6233 18.6848C33.7633 19.808 34.3333 21.1622 34.3333 22.7473C34.3333 24.3328 33.7633 25.6869 32.6233 26.8099C31.4833 27.9331 30.1089 28.4946 28.5 28.4946ZM16 38.5052V37.3492C16 36.5451 16.2217 35.8004 16.665 35.1152C17.1083 34.4299 17.7008 33.903 18.4425 33.5346C20.0897 32.739 21.7515 32.1423 23.4279 31.7443C25.1043 31.3464 26.795 31.1474 28.5 31.1474C30.205 31.1474 31.8957 31.3464 33.5721 31.7443C35.2485 32.1423 36.9103 32.739 38.5575 33.5346C39.2992 33.903 39.8917 34.4299 40.335 35.1152C40.7783 35.8004 41 36.5451 41 37.3492V38.5052C41 39.1977 40.7537 39.7866 40.2612 40.2721C39.7687 40.7574 39.171 41 38.4679 41H18.5321C17.829 41 17.2312 40.7574 16.7387 40.2721C16.2462 39.7866 16 39.1977 16 38.5052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.78fe4345ef990c0ada892908b25d0d9b.svg";
export { ForwardRef as ReactComponent };